// ** React Imports
import { useState } from "react"
import { Link } from "react-router-dom"

// ** Third Party Components
import { Power } from "react-feather"
import { useTranslation } from "react-i18next"
import { Tooltip } from "reactstrap"

// ** Context & Resources
import { userContext } from "@src/context/user"
import { USER_TYPES } from "@src/resources/enums"
import useLogin from "@src/hooks/user/useLogin"
import { getInitials } from "@utils"

// ** Card de usuario al pie del sidebar.
//
// Bloque nuevo del rediseño: en la plantilla el usuario solo aparecía en el navbar
// (el antiguo UserDropdown). Aquí se concentra todo lo que es "quién soy y cómo salgo":
// avatar de iniciales, nombre, "IBO · <código>" y el botón de cerrar sesión.
//
// El header de arriba se queda solo con idioma y avisos. Tener el nombre en los dos
// sitios era repetir la misma información en la misma pantalla.
//
// Ojo al anidado: el identificador es un <Link> y salir es un <button>, hermanos dentro
// del contenedor. Meter el botón dentro del enlace sería HTML inválido y, en la práctica,
// pulsar "salir" navegaría al perfil además de cerrar sesión.

// Solo el IBO lleva línea de identificación, con su código de userInfo.code.
// Para los demás tipos de usuario no se muestra nada: no tienen un código equivalente
// y rellenar el hueco con la etiqueta del rol a secas no aporta.
const IBO_LABEL = "IBO"

const SidebarUserCard = () => {
  const { t } = useTranslation()
  const { user } = userContext()
  const { logout } = useLogin(t)
  const [tipOpen, setTipOpen] = useState(false)

  if (!user) return null

  const fullName = [user.name, user.lastName].filter(Boolean).join(" ")
  const isIbo = user.userTypeId === USER_TYPES.IBO
  const meta = isIbo ? [IBO_LABEL, user.code].filter(Boolean).join(" · ") : null

  return (
    <div className="bp-sidebar-user">
      <div className="bp-sidebar-user__inner">
        <Link to="/profile" className="bp-sidebar-user__identity" title={t("Profile")}>
          <span className="bp-sidebar-user__avatar">
            {user.imageUrl ? (
              <img src={user.imageUrl} alt={fullName || "avatar"} />
            ) : (
              getInitials(user)
            )}
          </span>
          <span className="bp-sidebar-user__body">
            <span className="bp-sidebar-user__name d-block">
              {fullName || user.email}
            </span>
            {meta ? (
              <span className="bp-sidebar-user__meta d-block">{meta}</span>
            ) : null}
          </span>
        </Link>

        <button
          type="button"
          id="sidebar-logout"
          className="bp-sidebar-user__logout"
          onClick={logout}
          aria-label={t("Logout")}
        >
          <Power size={17} />
        </button>
        <Tooltip
          placement="top"
          isOpen={tipOpen}
          target="sidebar-logout"
          toggle={() => setTipOpen(!tipOpen)}
        >
          {t("Logout")}
        </Tooltip>
      </div>
    </div>
  )
}

export default SidebarUserCard
